import React from 'react';
import './HeroSec.css';

const HeroSec = () => {
  return (
    <div>
        <div className='contain '>
            <img className='bgg-1'src='./bg.png'alt='hhh'/>
        </div>
    </div>
  )
}

export default HeroSec